import { darken } from 'polished';
import React from 'react';
import styled, { css } from 'styled-components';
import { Icon } from '../Icon';
import { theme } from '../theme';
import { focusOutline } from '../utils/focusOutline';
export const Link = ({ className, href, onClick, openInNewTab, download, children, typo = 'regular', highlight = false, iconToRender = openInNewTab ? 'new-window' : undefined, isTrailingIcon = true, }) => {
    return (React.createElement(LinkWrapper, { href: href, className: className, onClick: onClick, download: download, "$typo": typo, "$highlight": highlight, ...(openInNewTab && {
            rel: 'noopener noreferrer',
            target: '_blank',
        }) },
        iconToRender && !isTrailingIcon && (React.createElement(Icon, { mt: { custom: '3px' }, mr: { custom: '4px' }, render: iconToRender, size: typo === 'regular' ? 14 : 12, color: highlight ? 'lollipop' : 'liquorice' })),
        children,
        iconToRender && isTrailingIcon && (React.createElement(Icon, { mt: { custom: '3px' }, ml: "8px", render: iconToRender, size: typo === 'regular' ? 14 : 12, color: highlight ? 'lollipop' : 'liquorice' }))));
};
const LinkWrapper = styled.a(({ $typo, $highlight }) => css `
    ${focusOutline()}
    display: inline-flex;
    flex-direction: row;

    ${$typo === 'regular' &&
    css `
      font-size: 16px;
      line-height: 20px;
    `}

    ${$typo === 'small' &&
    css `
      font-size: 14px;
      line-height: 20px;
    `}

      font-weight: ${theme.font.weight.medium};
    text-decoration: underline;
    color: ${$highlight ? theme.colors.lollipop : theme.colors.liquorice};

    background: none;
    cursor: pointer;

    &:hover {
      color: ${theme.colors.sesame};

      path {
        fill: ${theme.colors.sesame};
      }
    }

    &:active {
      color: ${theme.colors.liquorice};

      path {
        fill: ${theme.colors.liquorice};
      }
    }
  `);
/**
 * Internal utility to override styling in other components (see Text)
 * @internal
 */
export const linkStyleOverride = ({ color }) => css `
  & ${LinkWrapper} {
    color: ${color};

    path {
      fill: ${color};
    }

    &:hover {
      color: ${darken(0.1, color)};

      path {
        fill: ${darken(0.1, color)};
      }
    }
  }
`;
//# sourceMappingURL=Link.js.map